module.exports = __webpack_public_path__ + "img/RECUADRO_Desarrollo_XS.d0f1b7ad.png";